import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { BUSINESS } from "@/data/business";

const NAV = [
  { label: "About", href: "#about" },
  { label: "Products", href: "#products" },
  { label: "Types", href: "#types" },
  { label: "Gallery", href: "#gallery" },
  { label: "Enquiry", href: "#enquiry" },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-500 ${
        scrolled
          ? "bg-white/95 backdrop-blur-md border-b border-[color:var(--nitc-border)]"
          : "bg-white/80 backdrop-blur-sm"
      }`}
    >
      <div className="container-nitc flex items-center justify-between h-20">
        <a href="#top" data-testid="nav-logo-link" className="flex items-center gap-3 group">
          <div className="h-11 w-11 rounded-full bg-white flex items-center justify-center overflow-hidden ring-1 ring-black/10">
            <img src={BUSINESS.logo} alt="NITC" className="h-9 w-9 object-contain" />
          </div>
          <div className="flex flex-col leading-none">
            <span className="font-display text-[15px] sm:text-base font-semibold text-[color:var(--nitc-ink)] tracking-tight">
              New India
            </span>
            <span className="text-[10px] sm:text-[11px] tracking-[0.22em] uppercase text-[color:var(--nitc-muted)] mt-0.5">
              Trading Corporation
            </span>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-9" aria-label="Primary">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-link-${n.label.toLowerCase()}`}
              className="text-sm font-medium text-[color:var(--nitc-text)] hover:text-[color:var(--nitc-accent)] transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={`tel:${BUSINESS.phoneRaw}`}
            data-testid="header-call-button"
            className="hidden sm:inline-flex items-center gap-2 text-sm font-medium text-[color:var(--nitc-ink)] hover:text-[color:var(--nitc-accent)] transition-colors"
          >
            <Phone className="h-4 w-4" />
            {BUSINESS.phone}
          </a>
          <a
            href="#enquiry"
            data-testid="header-enquiry-button"
            className="hidden sm:inline-flex items-center bg-[color:var(--nitc-accent)] hover:bg-[color:var(--nitc-accent-hover)] text-white text-sm font-medium px-5 py-2.5 rounded-md transition-colors"
          >
            Get a Quote
          </a>
          <button
            onClick={() => setOpen((o) => !o)}
            className="lg:hidden p-2 rounded-md hover:bg-[color:var(--nitc-bg-2)]"
            aria-label="Toggle navigation"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[color:var(--nitc-border)] bg-white">
          <div className="container-nitc py-6 flex flex-col gap-5">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${n.label.toLowerCase()}`}
                className="text-base font-medium text-[color:var(--nitc-ink)]"
              >
                {n.label}
              </a>
            ))}
            <a
              href="#enquiry"
              onClick={() => setOpen(false)}
              data-testid="mobile-nav-enquiry-cta"
              className="mt-2 inline-flex w-fit items-center bg-[color:var(--nitc-accent)] text-white text-sm font-medium px-5 py-2.5 rounded-md"
            >
              Get a Quote
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
